import { connect } from 'react-redux'

import { CancelledGroupOrderTable } from '@components/groupOrders'

import services from '@services'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService } = services
  const { GetCancelledSubOrders } = coordinators
  const getCancelledSubOrders = GetCancelledSubOrders({
    RestService,
    HandleError,
  })

  return {
    getCancelledSubOrders,
  }
}

export default connect(null, mapDispatchToProps)(CancelledGroupOrderTable)
